<template>
  <v-container fluid id="routes-container">
    <v-row>
      <v-col cols="2">
        <v-select
          :items="filter_items"
          label="Search filter by"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="mdi-magnify"
          label="Search keywords"
          @keydown.enter="searchItem"
        ></v-text-field>
      </v-col>
      <v-col background-color="light-blue">
        <v-btn dark color="indigo" @click="searchItem" class="mt-2">
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
    </v-row>
    <h4
      class="text-uppercase indigo--text text--lighten-2 ml-4"
      v-if="fetchComplete"
    >
      Assigned Route
    </h4>
    <div v-if="fetchComplete" class="mb-10">
      <SecondaryRoutes
        :routeId="initiator_id"
        :child="selectedAssignedSubRoute"
        :routeType="'secondaryroute'"
        :inSubRoute="false"
        :isInitiator="true"
        :userAccess="selectedAssignedSubRoute.user_id"
        :accessRoute="selectedAssignedSubRoute.id"
        :accessFrom="'assigned_route'"
        :mainDocument="selectedDocuments[0]"
        :parentRouteDue="parent_route.datetime_due"
      />
    </div>
    <h5
      class="text-uppercase indigo--text text--lighten-2"
      style="margin-left: 100px"
      v-if="fetchComplete"
    >
      Initiated Route
    </h5>
    <v-row class="mx-1 mb-8">
      <v-col cols="11" offset="1" v-if="fetchComplete">
        <InitiatorRoute
          :fetchComplete="fetchComplete"
          :initiatorRoute="selectedRoute"
          :initiatorAccess="false"
        />
      </v-col>
      <v-col cols="12" v-else>
        <div class="text-center" style="margin-top: 250px">
          <v-progress-circular
            :size="100"
            :width="7"
            color="indigo"
            indeterminate
          ></v-progress-circular>
          <h2 class="mt-12 grey--text darken-3">Please wait...</h2>
        </div>
      </v-col>
    </v-row>
    <div v-if="showParent" class="mb-8">
      <h5
        class="text-uppercase indigo--text text--lighten-2"
        style="margin-left: 100px"
        v-if="fetchComplete"
      >
        Parent Route
      </h5>
      <v-row class="mt-n3" v-if="fetchComplete">
        <v-col cols="11" offset="1">
          <SecondaryRoutes
            :routeId="initiator_id"
            :child="parent_route"
            :routeType="'secondaryroute'"
            :inSubRoute="false"
            :isParent="true"
            :userAssigned="parent_route.user_id"
            :isInitiator="false"
          />
        </v-col>
      </v-row>
    </div>
    <div v-if="sibling_routes.length > 0">
      <h5
        class="text-uppercase indigo--text text--lighten-2"
        style="margin-left: 100px"
      >
        Sibling Routes
      </h5>
      <v-row class="mt-n3" v-for="child in sibling_routes" :key="child.id">
        <v-col cols="11" offset="1">
          <SecondaryRoutes
            :routeId="initiator_id"
            :child="child"
            :routeType="'secondaryroute'"
            :inSubRoute="false"
            :isSibling="true"
            :userAccess="selectedAssignedSubRoute.user_id"
            :accessRoute="selectedAssignedSubRoute.id"
            :isInitiator="false"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import SecondaryRoutes from "../../components/sub_routes/SecondaryRoutes";
  import InitiatorRoute from "../../components/routes/InitiatorRoute";

  export default {
    name: "RouteAssigned",
    components: {
      SecondaryRoutes,
      InitiatorRoute,
    },
    data() {
      return {
        fetchComplete: false,
        assigned_route_id: this.$route.params.id,
        initiator_id: this.$route.query.init,
        parent_id: this.$route.query.parent,
        search: "",
        filter_items: [
          "Route Name",
          "Document Name",
          "Regional Employee",
          "Record Name",
        ],
        initiator_route: null,
        parent_route: null,
        route_name: "",
        route_id: "",
        statuses: [],
        show: false,
        showParent: this.$route.query.parent ? true : false,
        assigned_route: null,
        sibling_routes: [],
        initiator_statuses: [],
        route_comment_dialog: false,
      };
    },
    methods: {
      ...mapActions(["fetchAssignedSubRouteId"]),
      searchItem() {
        alert(this.search);
      },
      routeWarning(val) {
        if (val) {
          this.route_status = "Warning";
        }
      },
    },
    computed: {
      ...mapGetters([
        "selectedRoute",
        "selectedAssignedSubRoute",
        "selectedRouteAssignments",
        "selectedDocuments",
        "selectedRecords",
        "selectedRouteRecordRequests",
        "loggedInPosition",
      ]),
      computedStatuses: function() {
        return this.initiator_statuses;
      },
      computedStatusColor: function() {
        var color = "";

        if (this.route_status == "Pending") {
          color = "";
        } else if (this.route_status == "Done") {
          color = "green lighten-4";
        } else if (this.route_status == "Overdue") {
          color = "red lighten-4";
        } else if (this.route_status == "Warning") {
          color = "yellow lighten-4";
        } else {
          color = "";
        }

        return color;
      },
    },
    created() {
      const body = {
        assigned_route_id: this.assigned_route_id,
        initiator_id: this.initiator_id,
        parent_id: this.parent_id ? this.parent_id : null,
      };
      this.fetchAssignedSubRouteId(body).then(res => {
        if (res.error) {
          if (res.status == 403) this.$router.push({ name: "403" });
        }
        this.route_name = this.selectedRoute.name;
        this.route_id = this.selectedRoute.id;
        this.parent_route = this.selectedRoute.parent_route
          ? this.selectedRoute.parent_route
          : this.selectedRoute;
        this.assigned_route = this.selectedAssignedSubRoute;
        this.sibling_routes = this.selectedRouteAssignments;
        this.fetchComplete = true;
        this.initiator_statuses = this.selectedRoute.statuses;
      });
    },
  };
</script>

<style scoped>
  #routes-container {
    padding: 0px 200px;
    margin-top: 50px;
  }

  @media only screen and (max-width: 1484px) {
    #routes-container {
      padding: 0px 10px;
    }
  }
</style>
